module.exports = __webpack_public_path__ + "img/creature_off.294806f0.svg";